import React from "react";
import PropTypes from "prop-types";
import { withFormik } from "formik";
import Yup from "yup";
import { newAccountToBasic } from "../../../utils/planStringConversion";
import SignupTable from "../../Signup/SignupTable";
import Button from "../../Global/Buttons/Button";
import Form from "../../Global/Forms/Form";

const YourPlanForm = ({
  // Props passed from YourPlanPage
  signup,
  submitting,
  // Formik props
  values,
  handleChange,
}) => {
  // const handleApplyDiscountClick = (e) => {
  //   e.preventDefault();
  //   onApplyDiscountClick(values.discountCode);
  // };

  const hasFormChanged = () => {
    if (`user_details` in signup) {
      const signupValuesFormatted = {
        planType: newAccountToBasic(signup.user_details.plan),
        billingFrequency: signup.user_details.plan_freq,
      };

      const formikValuesFormatted = {
        planType: values.planType,
        billingFrequency: values.billingFrequency,
      };

      if (
        JSON.stringify(signupValuesFormatted) ===
        JSON.stringify(formikValuesFormatted)
      ) {
        return false;
      }
      return true;
    }
    return false;
  };

  const handleSubmit = (e) => {
    if (values.planType === `enterprise`) {
      e.preventDefault();
      window.location = `https://content.thecoachingmanual.com/enterprise-trial`;
    }
  };

  // const promoCode = (
  //   <PromoCode
  //     stripe={stripe}
  //     values={values}
  //     onChange={handleChange}
  //     onApplyDiscountClick={handleApplyDiscountClick}
  //     applyDiscountLoading={applyDiscountLoading}
  //   />
  // );

  let promoCodeAndBilling;
  if (hasFormChanged() === true && values.planType !== `enterprise`) {
    // If the user isn't in Stripe
    // promoCodeAndBilling = promoCode;
    // if (stripe.hasCard === true) {
    //   promoCodeAndBilling = promoCode;
    // } else {
    //   promoCodeAndBilling = (
    //     <div>
    //       <PaymentMethod
    //         values={values}
    //         errors={errors}
    //         touched={touched}
    //         onChange={handleChange}
    //       />
    //       {promoCode}
    //     </div>
    //   );
    // }
  }

  const formContainerClass = `signup-form m-b-5 signup-form--${values.planType}-selected`;

  return (
    <Form className={formContainerClass}>
      <fieldset>
        <div className="m-b-5">
          <SignupTable
            signup={signup}
            values={values}
            onChange={handleChange}
          />
        </div>

        {values.planType !== `basic` && promoCodeAndBilling}

        <div className="text-right form-group">
          <Button
            type="submit"
            onClick={handleSubmit}
            size="l"
            disabled={hasFormChanged() === false}
            loading={submitting}
          >
            Change plan
          </Button>
        </div>
      </fieldset>
    </Form>
  );
};

YourPlanForm.propTypes = {
  signup: PropTypes.object.isRequired,
  submitting: PropTypes.bool.isRequired,
  // Formik
  values: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
};

const FormikYourPlanForm = withFormik({
  enableReinitialize: true,
  mapPropsToValues({ signup, stripe }) {
    let cardNumber;
    let nameOnCard;
    let expiryMonth;
    let expiryYear;
    let billingLine1;
    let billingLine2;
    let billingCity;
    let billingState;
    let billingZip;
    let billingCountry;

    if (stripe.hasCard === true) {
      cardNumber = stripe.customerDetails.cardNumber;
      nameOnCard = stripe.customerDetails.cardName;
      expiryMonth = stripe.customerDetails.cardMonth;
      expiryYear = stripe.customerDetails.cardYear;
      billingLine1 = stripe.customerDetails.cardAddressLine1;
      billingLine2 = stripe.customerDetails.cardAddressLine2;
      billingCity = stripe.customerDetails.cardCity;
      billingState = stripe.customerDetails.cardState;
      billingZip = stripe.customerDetails.cardZip;
      billingCountry = stripe.customerDetails.cardCountry;
    }

    let planType;
    // The default billing frequency set by the organisation
    // This is overridden below if the user has a plan frequency set
    let billingFrequency = signup.billing_frequency;

    if (`user_details` in signup) {
      planType = newAccountToBasic(signup.user_details.plan);

      // If the users plan frequency is null (which it will be if they are on the basic plan)
      // then we don't set the billing frequency, instead it remains as the default for the org
      if (signup.user_details.plan_freq) {
        billingFrequency = signup.user_details.plan_freq;
      }
    }

    return {
      planType,
      billingFrequency: billingFrequency || ``,
      cardNumber: cardNumber || ``,
      cvc: ``,
      nameOnCard: nameOnCard || ``,
      expiryMonth: expiryMonth || ``,
      expiryYear: expiryYear || ``,
      billingLine1: billingLine1 || ``,
      billingLine2: billingLine2 || ``,
      billingCity: billingCity || ``,
      billingState: billingState || ``,
      billingZip: billingZip || ``,
      billingCountry: billingCountry || ``,
      discountCode: ``,
    };
  },
  // Dynamic form validation based on if the user is in Stripe or not https://github.com/jaredpalmer/formik/issues/145
  validationSchema: () => Yup.lazy(() => Yup.object().shape()),
  handleSubmit(values, bag) {
    bag.props.onSubmit(values);
  },
})(YourPlanForm);

export default FormikYourPlanForm;



// WEBPACK FOOTER //
// ./library/app/components/Account/YourPlan/YourPlanForm.js